import get from 'lodash/get';
import { Station } from '@app/core/types/stations';

export function isAuditEnabled(station: Station): boolean {
  return get(station, 'featuresConfig.audit.enabled', false);
}

export function isAdOverlayEnabled(station: Station): boolean {
  return (
    get(station, 'featuresConfig.videoAnalysis.enabled', false) &&
    get(station, 'featuresConfig.videoAnalysis.adOverlays.enabled', false)
  );
}

/**
 * Generates a short hash from an object containing from/to dates
 */
export function generateShortHash(obj: object): string {
  const str = JSON.stringify(obj);
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  // Convert to positive number and then to base36 for shorter string
  const positiveHash = Math.abs(hash);
  return positiveHash.toString(36).substring(0, 8);
}
